import { render, staticRenderFns } from "./tabsSection.vue?vue&type=template&id=4ee50651&scoped=true"
import script from "./tabsSection.vue?vue&type=script&lang=js"
export * from "./tabsSection.vue?vue&type=script&lang=js"
import style0 from "./tabsSection.vue?vue&type=style&index=0&id=4ee50651&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee50651",
  null
  
)

export default component.exports